import React from "react";
import { Modal } from "react-bootstrap";
import { Button,  ThemeProviderV2} from '@blueprint/ui';
import { useModal } from "react-modal-hook";
import { useHistory } from "react-router-dom";

import { useAuthErrorHandlerCreator } from "../../../common/hooks";
import { BesuClaimState } from "../../../types/claim";
import { Handler } from "../../../types/common";
import { InvoiceState } from "../../../types/invoice";
import { BesuProjectState } from "../../../types/project";

const useFinanceApproveInvoiceHandler = (
    project: BesuProjectState,
    claim: BesuClaimState,
    invoice: InvoiceState,
    invoiceRef: string,
): Handler => {
    const history = useHistory();
    const onAuthError = useAuthErrorHandlerCreator();

    const [show, hide] = useModal(() => {
        const confirm = async () => {
            history.push(
                `/project/${project.referenceId}/claim/${claim.referenceId}/invoice/${invoice.linearId.id}/new-payment`,
            );
        };

        return (
            <ThemeProviderV2>
            <Modal show onHide={hide} backdrop="static" centered>
                <Modal.Header>
                    <h2 className="mb-0">
                        Approve Invoice Submission
                    </h2>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Are you sure you want to approve this invoice
                        submission?
                    </p>
                    <p>
                        By clicking the ‘Confirm’ button, you will be brought to
                        another page to initiate the payment instructions.
                    </p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between px-3">
                    <Button variant="light.tertiary" onClick={hide}>
                        Cancel
                    </Button>
                    <Button variant="light.primary" onClick={confirm}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
            </ThemeProviderV2>
        );
    }, [project, claim, invoice, invoiceRef, onAuthError]);

    return {
        isSubmitting: false,
        handler: show,
    };
};

export default useFinanceApproveInvoiceHandler;
